import { ChartPoint, RawFieldData } from "../interface/interface";

type GroupedFieldData = Record<string, ChartPoint[]>;

export const groupDataByField = (rawData: RawFieldData[]): GroupedFieldData => {
  const grouped: GroupedFieldData = {};

  rawData.forEach(({ timeStamp, fieldName, fieldValue }) => {
    if (!grouped[fieldName]) {
      grouped[fieldName] = [];
    }

    grouped[fieldName].push({
      _time: timeStamp,
      _value: fieldValue,
    });
  });

  return grouped;
};
